const LV = {
  language: "LV",
  contacts: "kontakti",
  parquet: "parkets",
  care_products: "kopšanas līdzekļi",
  tools: "instrumenti",
  events: "pasākumiem",
  home: "mājai",
  office: "birojam",
  beginning: "sākums",
  floor_coating: "grīdas segumi",
  parquet_coating: "PARKETA GRĪDAS SEGUMI",
  address: "adrese",
  office_address: "Birojs",
  warehouse_address: "Noliktava",
  consultant_text_1: "Sveiki! Mani sauc ",
  consultant_text_2_1: "Es palīdzēšu Jums izvēlēties paklāja segumu ",
  consultant_text_2_2: "mājai un birojam.",
  consultant_text_2_3: "pasākumiem.",
  consultant_text_3:
    "Es palīdzēšu Jums izvēlēties instrumentus un kopšanas līdzekļus.",
  consultant_tools: "Es palīdzēšu Jums izvēlēties instrumentus.",
  consultant_celaning: "Es zinu, kā Jūsu grīdu padarīt tīrāku un skaistāku.",
  consultation_title: "Saņemiet konsultāciju",
  consultation_parquet: "Es palīdzēšu Jums piemeklēt parketa grīdu mājai!",
  consultation_text:
    "Nosūtiet mums tālruņa numuru un vārdu - mēs jums piezvanīsim un atbildēsim uz jūsu jautājumiem.",
  name: "Vārds",
  send: "Nosūtīt",
  salon: "saloni",
  factory: "rūpnieciskās telpas",
  store: "veikali",
  auto: "autosaloni",
  house: "privātmājas",
  kid: "bērnu dārzi",
  restaurant: "restorāni",
  hotel: "viesnīcas",
  school: "skolas",
  gym: "sporta zāles",
  client_office: "biroji",
  client_title: "mūsu klienti",
  client_list: "mūsu apmierinātie klienti",
  developers: "Izstrādātāji",
  page_design: "Lapas dizains",
  budget_class: "budžeta klase",
  premium_class: "premium klase",
  grande: "grande kolekcija",
  grande_collection: "grande kolekcija",
  xl_collection: "xl kolekcija",
  rockefeller: "rockefeller kolekcija",
  rockefeller_collection: "rockefeller kolekcija",
  design_studio: "dizaina studija",
  budget_material: "budžeta materiāli",
  premium_material: "premium materiāli",
  podium_soft: "Podium mīkstie segumi",
  other_soft: "citi mīkstie segumi",
  linoleum: "linolejs",
  grass: "zālīte",
  open_hours: "Darba laiks",
  oak_boards: "Ozola dēļi",
  conifer: "Skujiņa",
  strips: "Garloksnes",
  other_boards: "Citas koku sugas dēļi",
  tiles: "Flīzēm",
  terrace: "Terasei",
  linoleum_pvc_lvt: "Linolejam, pvc, lvt",
  laminate_parquet_kork: "laminātam, parketam, korķim",
  carpet: "paklājiem",
  volume: "Tilpums",
  consumption: "Patēriņš",
  product_modal_contact_text:
    "Nosūtiet mums tālruņa numuru un vārdu - mēs Jums sniegsim pilnu informāciju par produktu, vai zvaniet mums uzreiz:",
  event_product_page_text:
    "Vairāk nekā 100 dažādu kolekciju paklāji ļauj izvēlēties labu, nodilumizturīgu, ilgi kalpojošu un viegli kopjamu mīksto segumnu sabiedriskajās telpās- birojos, klientu apkalpošanas zonās, viesnīcās un dzīvojamajās telpās. Paklājs telpā radīs mājīgāku vidi, absorbēs trokšņus un noslēps ikdienas netīrumus.",
  width: "Platums",
  style: "Stils",
  surface_treatment: "Virsmas apstrāde",
  surface_coating: "Virsmas pārklājums",
  error_404: "Kļūda 404 - Lapa netika atrasta",
  know_more: "Uzzināt vairāk",
  jazz_tiles: "jazz flīzes",
  turbo_tiles: "turbo flīzes",
  primavera_tiles: "primavera flīzes",
  secret_escape: "secret escape",
  secret_garden: "secret garden",
  sense_pure: "sense pure",
  expedition_collection: "expedition collection",
  current_offer: "Aktuālais piedāvājums",
  strips_oak: "ozols",
  strips_ash: "osis",
};

export default LV;
